import type { ReaderPdfBookOverview } from "@/interface/DTO_Interfaces"
import { getContentJson } from "@/ts/api/content"

export const loadReaderPdfBookOverview = async (src: string): Promise<ReaderPdfBookOverview> => {
        return getContentJson<ReaderPdfBookOverview>(src, "Не удалось загрузить сведения об учебнике")
}
